import axios from "axios";
import React, { useEffect, useMemo } from "react";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "../../components/Button";
import { Loader } from "../../components/Loader";
import { Table } from "../../components/Table";
// import logo from "../../images/singleLogo.png";

export const Devices: React.FC = () => {
  const { restId, branchId } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, refetch } = useQuery("Get Devices", async () => {
    const response = await axios.get(`/restaurant/devices/${branchId}`);
    return response.data.devices.map((el: any, index: number) => ({
      id: index + 1,
      name: el.name,
      device_id: el.device_id,
      actions: (
        <Button lightBlue onClick={() => downloadQRCode(el.name, el.device_id)}>
          Print QR
        </Button>
      ),
      qr: (
        <QRCodeCanvas
          id="qr-gen"
          className="hidden"
          value={`{"1": "${restId}", "2": "${el.device_id}", "3": "${
            process.env.REACT_APP_WEB_INVOICE_URL as string
          }?restId=${restId}&deviceId=${el.device_id}"}`}
          // imageSettings={imageSettings}
          fgColor={"#000000"}
          bgColor={"#FFFFFF"}
          level={"H"}
          size={255}
          includeMargin={true}
        />
      ),
    }));
  });

  // const imageSettings = {
  //   src: logo,
  //   excavate: true,
  //   height: 40,
  //   width: 40,
  // };

  const downloadQRCode = (name: string, device_id: string) => {
    const canvas = document.getElementById("qr-gen") as any;
    const pngUrl = canvas
      ?.toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `${name} - ${device_id}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "id",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "",
        accessor: "actions",
      },
      {
        Header: "",
        accessor: "qr",
      },
    ],
    []
  );

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading)
    return (
      <div className="flex justify-center items-center pt-32">
        <Loader />
      </div>
    );

  return (
    <div>
      <header className="my-3 flex items-center gap-4">
        <Button
          lightRed
          className="h-fit"
          onClick={() => navigate(`/dashboard/restaurants/branches/${restId}`)}
        >
          Back
        </Button>
        <h3 className="text-2xl font-medium py-4">Branch Devices</h3>
      </header>
      {data.length === 0 && !isLoading && (
        <div>Branch doesn't Contain Devices</div>
      )}
      {data.length > 0 && <Table columns={columns} data={data} filter={true} />}
    </div>
  );
};
